import React from "react";
import { Skeleton } from "@mui/material";
import { CONFIG_REF_LIST_CELL_TEST_ID, REF_CELL_LOADING_TEST_ID } from "../ExploreTab.consts";
import { getFieldRefInfo, resolveListLabels } from "../ExploreTab.utils";
import useConfigRefOptions from "../hooks/useConfigRefOptions.hook";
import ChipListCell from "./ChipListCell";

const ConfigRefListCell = ({ field, value }) => {
  const refInfo = getFieldRefInfo(field);
  const { labelByKey, resolveKey, isLoading, isSuccess } = useConfigRefOptions({
    scalarName: refInfo?.scalarName,
    collectionId: refInfo?.collectionId,
    queryParams: refInfo?.queryParams
  });
  const hasValues = Array.isArray(value) && value.length > 0;

  if (hasValues && isLoading) return <Skeleton variant="text" width="70%" data-testid={REF_CELL_LOADING_TEST_ID} />;
  const { labels, invalidIndexes } = hasValues && isSuccess
    ? resolveListLabels(value, { labelByKey, resolveKey })
    : { labels: null, invalidIndexes: undefined };
  return (
    <ChipListCell
      value={labels}
      invalidIndexes={invalidIndexes}
      testId={CONFIG_REF_LIST_CELL_TEST_ID}
    />
  );
};

export default ConfigRefListCell;
